<div class="input-keypad">
  <div class="input-btn-row">
    <button
      pButton
      pRipple
      (click)="processKey('1')"
      id="input1"
      label="1"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('2')"
      id="input2"
      label="2"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('3')"
      id="input3"
      label="3"

    ></button>
  </div>
  <div class="input-btn-row">
    <button
      pButton
      pRipple
      (click)="processKey('4')"
      id="input4"
      label="4"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('5')"
      id="input5"
      label="5"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('6')"
      id="input6"
      label="6"

    ></button>
  </div>
  <div class="input-btn-row">
    <button
      pButton
      pRipple
      (click)="processKey('7')"
      id="input7"
      label="7"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('8')"
      id="input8"
      label="8"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('9')"
      id="input9"
      label="9"

    ></button>
  </div>
  <div class="input-btn-row">
    <button
      pButton
      pRipple
      (click)="processKey('*')"
      id="inputAsterisk"
      label="*"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('0')"
      id="input0"
      label="0"

    ></button>
    <button
      pButton
      pRipple
      (click)="processKey('#')"
      id="inputHash"
      label="#"

    ></button>
  </div>
</div>
